import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { FinnairBoundItem, FinnairPassengerItem } from '../../api/models';
import { FinnairServiceItemWithUpsell } from '../../interfaces';
import { getSeatsByFlight } from '../../utils';

interface FlightWithSeats {
  flight: string;
  seats: string[];
}

@Component({
  selector: 'fin-included-product-item-summary-seat',
  templateUrl: './included-product-item-summary-seat.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemSummarySeatComponent implements OnInit, OnChanges {
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;
  protected isSingleFlightBound = true;
  protected singleFlightSeats: string[] = [];
  protected flightsSeats: FlightWithSeats[] = [];

  ngOnChanges(): void {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  private update() {
    this.flightsSeats = [];
    const seatsByFlight = getSeatsByFlight(this.passengers, this.bound, this.service);
    if (seatsByFlight.size > 1) {
      this.isSingleFlightBound = false;
      this.singleFlightSeats = [];
      seatsByFlight.forEach((seats, flight) => {
        this.flightsSeats.push({ flight, seats });
      });
    } else {
      this.isSingleFlightBound = true;
      this.singleFlightSeats = seatsByFlight.values().next().value;
      this.flightsSeats = [];
    }
  }
}
